{
    "name": "site-monitoring-asset-and-road-threat-system-platform",
    "version": "1.0.0",
    "license": "MIT",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build --configuration production",
        "test": "ng test",
        "test-ci": "ng test --watch=false --coverage",
        "lint": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng lint",
        "lint:fresh": "npm run lint -- --no-cache",
        "bundle_analyzer": "webpack-bundle-analyzer ./dist/smarts-ng/stats.json"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^21.2.18",
        "@angular/cdk": "^21.2.14",
        "@angular/common": "^21.2.18",
        "@angular/compiler": "^21.2.18",
        "@angular/core": "^21.2.18",
        "@angular/forms": "^21.2.18",
        "@angular/localize": "^21.2.18",
        "@angular/material": "^21.2.14",
        "@angular/material-moment-adapter": "^21.2.14",
        "@angular/platform-browser": "^21.2.18",
        "@angular/platform-browser-dynamic": "^21.2.18",
        "@angular/router": "^21.2.18",
        "@azure/msal-browser": "^3.27.0",
        "@googlemaps/markerclusterer": "^2.6.2",
        "@jsonforms/angular": "3.8.0",
        "@jsonforms/angular-material": "3.8.0",
        "@jsonforms/core": "3.8.0",
        "@material/material-color-utilities": "^0.4.0",
        "@microsoft/applicationinsights-angularplugin-js": "^14.0.2",
        "@microsoft/applicationinsights-web": "^3.3.10",
        "@progress/kendo-angular-buttons": "23.2.2",
        "@progress/kendo-angular-common": "23.2.2",
        "@progress/kendo-angular-conversational-ui": "^23.2.2",
        "@progress/kendo-angular-dateinputs": "23.2.2",
        "@progress/kendo-angular-dialog": "23.2.2",
        "@progress/kendo-angular-dropdowns": "23.2.2",
        "@progress/kendo-angular-editor": "23.2.2",
        "@progress/kendo-angular-excel-export": "23.2.2",
        "@progress/kendo-angular-grid": "23.2.2",
        "@progress/kendo-angular-icons": "23.2.2",
        "@progress/kendo-angular-indicators": "23.2.2",
        "@progress/kendo-angular-inputs": "23.2.2",
        "@progress/kendo-angular-intl": "23.2.2",
        "@progress/kendo-angular-l10n": "23.2.2",
        "@progress/kendo-angular-label": "23.2.2",
        "@progress/kendo-angular-layout": "23.2.2",
        "@progress/kendo-angular-menu": "23.2.2",
        "@progress/kendo-angular-navigation": "23.2.2",
        "@progress/kendo-angular-pager": "23.2.2",
        "@progress/kendo-angular-pdf-export": "23.2.2",
        "@progress/kendo-angular-popup": "23.2.2",
        "@progress/kendo-angular-progressbar": "23.2.2",
        "@progress/kendo-angular-ripple": "23.2.2",
        "@progress/kendo-angular-scrollview": "23.2.2",
        "@progress/kendo-angular-sortable": "23.2.2",
        "@progress/kendo-angular-toolbar": "23.2.2",
        "@progress/kendo-angular-tooltip": "23.2.2",
        "@progress/kendo-angular-treelist": "23.2.2",
        "@progress/kendo-angular-treeview": "23.2.2",
        "@progress/kendo-angular-upload": "23.2.2",
        "@progress/kendo-angular-utils": "23.2.2",
        "@progress/kendo-data-query": "^1.7.3",
        "@progress/kendo-drawing": "^1.25.0",
        "@progress/kendo-licensing": "^1.11.0",
        "@progress/kendo-svg-icons": "^4.0.0",
        "@progress/kendo-theme-material": "^14.3.0",
        "ag-charts-angular": "^9.3.2",
        "ag-charts-community": "^9.3.2",
        "ajv": "^8.17.1",
        "dayjs": "^1.11.10",
        "dompurify": "^3.3.0",
        "gridstack": "^12.6.0",
        "htmldiff-js": "^1.0.5",
        "jsondiffpatch": "^0.7.6",
        "jwt-decode": "^4.0.0",
        "lodash": "^4.17.21",
        "mathjs": "^15.1.0",
        "moment": "^2.30.1",
        "ng2-pdf-viewer": "^10.4.0",
        "ngx-color": "^10.1.0",
        "ngx-countdown": "^16.0.0",
        "ngx-editor": "^16.0.1",
        "rxjs": "^7.8.2",
        "tslib": "^2.8.1",
        "uuid": "^13.0.0",
        "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular/build": "^21.2.18",
        "@angular/cli": "^21.2.18",
        "@angular/compiler-cli": "^21.2.18",
        "@angular/language-service": "^21.2.18",
        "@stylistic/eslint-plugin": "^5.10.0",
        "@types/dompurify": "^2.4.0",
        "@types/google.maps": "^3.58.1",
        "@types/lodash": "^4.17.25",
        "@types/node": "^22.20.3",
        "@vitest/coverage-v8": "^4.1.11",
        "angular-eslint": "^21.4.0",
        "cross-env": "^10.1.0",
        "eslint": "^10.0.0",
        "jsdom": "^30.0.1",
        "prettier": "3.9.6",
        "ts-node": "^10.9.2",
        "typescript": "~5.9.3",
        "typescript-eslint": "^8.66.0",
        "vitest": "^4.1.11",
        "webpack-bundle-analyzer": "^4.10.2"
    },
    "volta": {
        "node": "22.23.4"
    },
    "overrides": {
        "prosemirror-model": "1.20.0",
        "prosemirror-state": "1.4.3",
        "prosemirror-view": "1.33.4",
        "prosemirror-transform": "1.8.0",
        "prosemirror-commands": "1.5.2",
        "prosemirror-schema-list": "1.3.0"
    }
}
